const pt = {
  task: {
    center: "Centro de Tarefas",
    callTask: "Tarefa de chamada",
    giftTask: "Tarefa de presente",
    liveTask: "Tarefa de recém-chegado",
    sevenTask: "Tarefa de 7 dias",
    callMessage: "Ligue mais para obter recompensas",
    giftMessage: "Receba presentes para obter recompensas",
    liveMessage: "Aumente a duração do Live para obter uma recompensa de $10",
    sevenMessage: "Conclua as tarefas diárias para receber uma recompensa de $50",
    cellTitle: "Chamada ≥{d} minutos (vezes): ",
    reward: "Recompensa",
    lastWeek: "Recompensa da semana passada:",
    weekGift: "Receita semanal de presentes:",
    RewardDescription: "Instruções de recompensa",
    everyWeekGift: "Receita semanal de presentes<span class='web'>(Bonus)</span>",
    endTask: 'Tarefa encerrada',
    query: "Está bem"
  },
  message: {
    taxt1: "1. Cada ciclo de liquidação é de segunda a domingo. Quanto mais duração da videochamada ≥{d} minutos, mais generosas serão as recompensas.",
    taxt2: "2. Você só pode obter recompensas de um nível por semana, com base na avaliação dos tempos de duração de uma única chamada naquela semana ≥{d} minutos.",
    taxt3: "3. Após a verificação oficial, as recompensas serão emitidas para sua conta antes na próxima quinta-feira após o acordo.",
    taxt4: "4. Se houver trapaça, você será desqualificado para receber qualquer recompensa.",
    taxt5: "5. Se tiver alguma dúvida, consulte：<span class='web'>support@honeycamweb.com</span>",
    hint: "Notas: Sujeito ao horário internacional",
    rewardOne1: "1.Dentro de 7 dias após o início da tarefa",
    rewardOne2: "1) Live≥2 horas e a taxa de conclusão da chamada ≥80% ao dia por pelo menos 6 dias;",
    rewardOne3: "2) Dentro de 7 dias após o início da tarefa, a renda total atinge ≥{d}Bonus;",
    rewardOne4: "3) Se as condições acima forem atendidas ao mesmo tempo, você pode obter uma recompensa de <span style='color: #ff2794'>{d}</span> da plataforma após o término da tarefa;",
    rewardOne5: "2.Uma âncora pode recompensar uma conta no máximo, e várias contas são inválidas;",
    rewardOne6: "3.Se for encontrada trapaça, a qualificação para recompensas será cancelada;",
    rewardOne7: "4.O usuário que concluiu a tarefa, após o término da tarefa. Siga a página inicial oficial do <span class='web' style='color: #f99634'>Facebook \"Honeycam\"</span> e adicione um grupo para receber uma recompensa de <span style='color: #ff2794'>$10</span>;",
    rewardOne8: "5.Se tiver alguma dúvida, consulte：<span class='web'>support@honeycamweb.com;</span>",
    rewardTwo1: "Os usuários que ganham mais de {d} no dia durante a missão terão a oportunidade de entrar na primeira posição das páginas recomendadas ou populares no dia seguinte para ganhar mais exposição;"
  },
  gift: {
    test1: "1. O ciclo de liquidação é de segunda a domingo. Quanto mais presentes você recebe, mais generosas são as recompensas.",
    test2: "2. Você só pode obter recompensas por um nível por semana, e o nível é avaliado com base na receita total daquela semana.",
    test3: "3. Após a verificação oficial, o prêmio será emitido para sua conta de receita antes da próxima quinta-feira.",
    test4: "4. Se for encontrada trapaça, você será desqualificado para receber qualquer recompensa",
    test5: "5. Se tiver alguma dúvida, consulte：<span class='web'>support@honeycamweb.com</span>",
    giftNum: "Presentes recebidos ≥{d}",
    totalBonus: "Renda ≥{d}Bonus",
    liveCallTime: "<span class='web'>live</span>≥{d}(m)",
    callTime: "Chamada ≥{d}(m)",
    callRate: "接通率≥{d}%"
  },
  new: {
    rewardOne: "Recompensa Um",
    rewardTwo: "Recompensa Dois",
    start: "A tarefa foi inaugurada oficialmente às 0:00 de hoje",
    hint: "Mantenha o Live≥{d} horas e a taxa de conclusão da chamada ≥{d} ao dia.Você pode receber uma recompensa de {d}.",
    tastReward: "Receita total <span class='web'>Bonus</span> durante a missão",
    liveTime: "Duração do Live de hoje",
    callRate: "Taxa de conclusão de chamadas para hoje",
    progress: "Progresso da tarefa",
    endRate: "(meta ≥",
    overText1: "Parabéns pela conclusão da tarefa",
    overText2: "Siga o site oficial <span class='web'>Facebook \"Honeycam\"</span> e adicione um grupo para receber uma recompensa de {d}.",
    overText3: "É uma pena que a tarefa não tenha sido concluída e você não possa obter a recompensa de {d}",
    overText4: "Siga o oficial <span class='web'>Facebook \"Honeycam\"</span> para obter mais informações sobre a tarefa.",
    openfb: "Abra o <span class='web'>Facebook</span>",
  },
  week: {
    live30: "Amanhã Live≥{d} minutos",
    call5: "Amanhã chamada ≥5 minutos",
    rewardHint: "(Se todas as tarefas a seguir forem concluídas, <span style='color: #ff2794'>você receberá uma recompensa adicional de <span class='web'>$20</span></span>)",
    newLive: "Hoje Live",
    newLiveSec: "(meta ≥{d})",
    newCall: "Chamada de hoje",
    newCallRate: "Taxa de conclusão de chamadas para hoje",
    newBonus: "Renda Bonsu de hoje",
    newGift: "Número de presentes de hoje",
    newReward: "Recompensas de hoje",
    days: "Dias",
    taskReq: "Requisitos de tarefa",
    task1: "1.As tarefas de todos os dias são liquidadas às 0:00 e emitidas para a sua conta Bonus às 0:00;",
    task2: "2.Se a tarefa não for concluída naquele dia, ela falhará. A tarefa com falha não pode ser retomada;",
    task3: "3.Apenas todas as tarefas de 7 dias são concluídas, um pacote de recompensa de {d} pode ser obtido;",
    task4: "4.Uma âncora pode recompensar uma conta no máximo, e várias contas são inválidas;",
    task5: "5.Se for encontrada trapaça, a qualificação para recompensas será cancelada;",
    task6: "6.O usuário que concluiu a tarefa, após o término da tarefa. Siga a página inicial oficial do <span class='web' style='color: #f99634'>Facebook \"Honeycam\"</span> e adicione um grupo para receber uma recompensa de <span style='color: #ff2794' class='web'>$20</span>;",
    task7: "7.Se tiver alguma dúvida, consulte：<span class='web'>support@honeycamweb.com;</span>",
  }
};

export default pt;
